import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router';
import classNames from 'classnames';
import { Field, FieldArray, reset } from 'redux-form';
import { SkyLightStateless } from 'react-skylight';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Input, Breadcrumb, Textarea, Image } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';
import { Translate, I18n } from 'react-redux-i18n';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import Dropzone from 'react-dropzone';

import { InputField } from '../Common/inputField';
import ConfirmActionModal from '../Common/confirmActionModal';
import GenericSelection from '../Common/GenericSelection';
import PriceLevel from '../Common/priceLevel';
import Spinner from '../Widgets/spinner';
import { Selection, SelectionWithProps } from '../Common/selection';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import {
  ROOT_URL, ROOT_API_URL, isLAP, isAPD, isARC, isVAK, isDAICHEONG, isGGI, isABBLE,
  isOCM, isESC, isHMM, isOLG, isSV, isLE, isEKC, isLMH, isBRO, isSDR, isCRW, isTQ,
  isSW, isGFD, isSC, isSH, isAP, isCT
} from '../../actions/root_url';
import { AgentChangeModal } from '../Common/agentChangeModal';
import { PriceTableModal } from '../Common/priceTableModal';
import DuplicateToCompanyModal from './DuplicateToCompanyModal'
import { getImageUrl } from './apis';
import { DatePicker } from '../Common/datePicker';
import checkPermission from '../Common/permissions'
const isCalco = ROOT_API_URL === 'https://ct-scm.truckxi.com/api/' || ROOT_API_URL === 'http://ctstage-scm.truckxi.com/api/';
const isCO = ROOT_API_URL === 'https://co-scm.truckxi.com/api/' || ROOT_URL === 'https://co-scm.truckxi.com/api/';
const isFJ = ROOT_API_URL === 'https://fj-scm.truckxi.com/api/' || ROOT_URL === 'https://fj-scm.truckxi.com/api/';
const isMAG = ROOT_API_URL === 'https://magna-scm.truckxi.com/api/' || ROOT_URL === 'https://magna-scm.truckxi.com/api/';
const isWIZ = ROOT_API_URL === 'https://wiz-scm.truckxi.com/api/' || ROOT_URL === 'https://wiz-scm.truckxi.com/api/';
const isMultiWH = true;

const titleOptions = [{
  label: 'Owner',
  value: 'Owner',
}, {
  label: 'Boss',
  value: 'Boss',
}, {
  label: 'Sales',
  value: 'Sales',
}, {
  label: 'Purchase',
  value: 'Purchase',
}, {
  label: 'Operation',
  value: 'Operation',
}, {
  label: 'Account',
  value: 'Account',
}, {
  label: 'Manager',
  value: 'Manager',
}, {
  label: 'Others',
  value: 'Others',
}];

const dutyOptions = [{
  label: 'Frozen',
  value: 'Frozen',
}, {
  label: 'Dry',
  value: 'Dry',
}, {
  label: 'Both',
  value: 'Both',
}];

const typeOptions = [{
  label: 'Warehouse',
  value: 'Warehouse'
}, {
  label: 'Transportation',
  value: 'Transportation',
}, {
  label: 'Pick Up',
  value: 'Pick Up',
}, {
  label: 'Transfer Account',
  value: 'Transfer Account',
}, {
  label: 'Other',
  value: 'Other',
}]

const timeOptions = [
  { label: "00:00", value: "00:00" }, { label: "01:00", value: "01:00" },
  { label: "02:00", value: "02:00" }, { label: "03:00", value: "03:00" },
  { label: "04:00", value: "04:00" }, { label: "05:00", value: "05:00" },
  { label: "06:00", value: "06:00" }, { label: "07:00", value: "07:00" },
  { label: "08:00", value: "08:00" }, { label: "09:00", value: "09:00" },
  { label: "10:00", value: "10:00" }, { label: "11:00", value: "11:00" },
  { label: "12:00", value: "12:00" }, { label: "13:00", value: "13:00" },
  { label: "14:00", value: "14:00" }, { label: "15:00", value: "15:00" },
  { label: "16:00", value: "16:00" }, { label: "17:00", value: "17:00" },
  { label: "18:00", value: "18:00" }, { label: "19:00", value: "19:00" },
  { label: "20:00", value: "20:00" }, { label: "21:00", value: "21:00" },
  { label: "22:00", value: "22:00" }, { label: "23:00", value: "23:00" },
]

const renderEmails = (props) => {
  const { fields, already } = props;
  const showPlus = !isOLG || isOLG && (fields || []).length < 1;
  return (
    <Row>
      <Col xs={12} className="add-bin-range-section">
        {showPlus && <Row>
          <Col xs={12}>
            <Button
              bsStyle="primary"
              type="button"
              onClick={() => {
                if (isSH || isAP) {
                  fields.push({ BypassPayment: true })
                } else {
                  fields.push({}); // pushes empty child field onto the end of the array
                }
              }}
            >
              <em className="fa fa-plus" />
            </Button>
          </Col>
        </Row>}
        <Row>
          <Col xs={12}>
            {
              fields.map((email, index) => (
                <Row key={index} className="additional-bin-range">
                  <div className="customer-email-row">
                    <div className="customer-email-row-title" style={{ paddingLeft: '8px' }}>
                      {isOLG ?
                      <h4> #{index + 1}</h4>
                       :
                       <h4><Translate value="email" /> #{index + 1}</h4>
                       }
                    </div>
                    <div className="customer-email-row-fields">
                      <div className="customer-email-row-fields-input">
                        <div className="form-group">
                          <div className="col-xs-12">
                            <Field name={`${email}.email`} disabled={isOLG && already} component={InputField} placeholder={isOLG ? "Email Or Phone" : "Email"} />
                          </div>
                        </div>
                      </div>
                      {!isOLG && <div className="customer-email-row-fields-checkbox-section">
                        <ReactTooltip id="bypass-checkbox" place="top" type="dark" effect="solid">
                          {I18n.t('tooltip_customer_bypass_payment')}
                        </ReactTooltip>
                        <ReactTooltip id="showall-checkbox" place="top" type="dark" effect="solid">
                          {I18n.t('tooltip_customer_manager')}
                        </ReactTooltip>
                        <div className="customer-email-row-fields-checkbox">
                          <Field
                            name={`${email}.BypassPayment`}
                            component="input"
                            type="checkbox"
                          />
                          <span data-tip data-for="bypass-checkbox" >
                            {I18n.t('bypass')}
                          </span>
                        </div>
                        <div className="customer-email-row-fields-checkbox">
                          <Field
                            name={`${email}.IsManager`}
                            component="input"
                            type="checkbox"
                            disabled={isOLG}
                          />
                          <span data-tip data-for="showall-checkbox" >
                            {I18n.t('manager')}
                          </span>
                        </div>
                      </div>}
                    </div>
                    {/*
                      hiding for now since we may bring it back
                      <Col xs={ 2 }>
                        <Button
                          bsStyle="danger"
                          className="remove-btn"
                          type="button"
                          onClick={() => {
                            fields.remove(index)  // remove from index
                          } }>
                          <em className="fa fa-trash"/>
                        </Button>
                      </Col>
                    */}
                  </div>
                </Row>
              ))
            }
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

const renderIsDefault = (props) => {
  // Bad implementation, cannot set the value attribute of Input componnet to a boolean.
  const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'control-label');
  return (
    <div className="boolean-field">
      {props.meta.touched && props.meta.error && <span className="parsley-error-message">{props.meta.error}</span>}
      <label className={titleClass}><Translate value="default_address" /></label>
      <label className="boolean">
        <Input {...props.input} type="radio" value={true} checked={props.input.value === true || props.input.value === 'true'} />
        <Translate value="yes" />
      </label>
      <label className="boolean">
        <Input {...props.input} type="radio" value={false} checked={props.input.value === false || props.input.value === 'false'} />
        <Translate value="no" />
      </label>
    </div>
  );
};

const renderAfterAddonField = (props) => (
  <Input {...props.input} standalone type="text" standalone addonAfter=".00" style={{ zIndex: 0 }} />
);

const renderRadios = (props) => {
  const titleClass = classNames({ 'parsley-error-label': props.meta.touched && props.meta.error }, 'control-label')
  return (
    <div className="boolean-field">
      {props.meta.touched && props.meta.error && <span className="parsley-error-message">{props.meta.error}</span>}
      {props.error && console.log(props.input.name + ' ' + props.error)}
      {props.input.name === 'IsWholesale' && <label className={titleClass} ><Translate value="wholesale" /></label>}
      {props.input.name === 'IsShowPrice' && <label className={titleClass} ><Translate value="show_price" /></label>}
      {props.input.name === 'IsActive' && <label className={titleClass} ><Translate value="active" /> <Translate value="customer" /></label>}
      {props.input.name === 'IsPrtReminder' && <label className={titleClass} ><Translate value="print_reminder" /></label>}
      {props.input.name === 'IsPrtGeneralInfor' && <label className={titleClass} ><Translate value="print_general_information" /></label>}
      {props.input.name === 'IsInternal' && <label className={titleClass} ><Translate value="internal" /></label>}
      {props.input.name === 'HasCRV' && <label className={titleClass} ><Translate value="has_CRV" /></label>}
      {props.input.name === 'QuickbookAccount' && <label className={titleClass} ><Translate value="quickbook_account" /></label>}
      {props.input.name === 'IsEmailInvoice' && <label className={titleClass} ><Translate value="email_invoice" /></label>}
      <div className="boolean">
        <label>
          <Input {...props.input} type="radio" disabled={(isLAP || isAPD) && props.input.name === 'IsActive' && !checkPermission('active_customer')} value={isVAK && props.input.name === 'QuickbookAccount' ? 'VK' : "true"} checked={props.input.name === 'QuickbookAccount' && props.input.value == 'VK' || (props.input.value === true || props.input.value === 'true')} />
          <Translate value={isVAK && props.input.name === 'QuickbookAccount' ? 'vk' : "yes"} />
        </label>
      </div>
      <div className="boolean">
        <label>
          <Input {...props.input} type="radio" disabled={(isLAP || isAPD) && props.input.name === 'IsActive' && !checkPermission('active_customer')} value={isVAK && props.input.name === 'QuickbookAccount' ? 'EZ' : "false"} checked={props.input.name === 'QuickbookAccount' && props.input.value == 'EZ' ||  (props.input.value === false || props.input.value === 'false')} />
          <Translate value={isVAK && props.input.name === 'QuickbookAccount' ? 'ez' : "no"} />
        </label>
      </div>
    </div>
  );
};

// Helping function to render a multi-fields form. Reference on redux-form array.
const countriesOptions = [
  { label: 'AU', value: 'AU' },
  { label: 'BR', value: 'BR' },
  { label: 'CA', value: 'CA' },
  { label: 'DE', value: 'DE' },
  { label: 'FR', value: 'FR' },
  { label: 'JP', value: 'JP' },
  { label: 'GB', value: 'GB' },
  { label: 'KR', value: 'KR' },
  { label: 'ME', value: 'ME' },
  { label: 'NZ', value: 'NZ' },
  { label: 'RU', value: 'RU' },
  { label: 'SG', value: 'SG' },
  { label: 'US', value: 'US' },
  { label: 'UK', value: 'UK' },
];
class renderShipping extends Component {
  constructor() {
    super();
    this.state = {
      confirmOpen: false,
      agentModalOpen: false,
      ptModalOpen: false,
      tempDisplay: [],
      // prevOrderDate: null,
    }
  }

  componentDidMount() {
  }

  componentWillReceiveProps(nextProps) {
    if (isSV) {
      this.setState({tempDisplay: nextProps.shipping});
    }
  }

  copyBillingToShipping(e) {
    e.preventDefault();
    const shippingInfo = { ...this.props.billing, Type: 'Shipping' };
    const { shipping } = this.props;
    if (shipping && shipping.length > 0 && shipping[0]) {
      shippingInfo.CustomerDetail_id = shipping[0].CustomerDetail_id;
    } else {
      delete shippingInfo.CustomerDetail_id;
    }
    this.props.changeFieldArrayOfForm('Shipping', 0, shippingInfo, 'customerForm');
  }

  renderDeleteButton(index, fields) {
    return (
      <Button
        bsStyle="danger"
        className="trash"
        type="reset"
        onClick={() => {
          fields.remove(index);
        }}
      >
        <em className="fa fa-trash-o" />
      </Button>
    );
  }

  renderAutoFillButton() {
    return (
      <Button
        bsStyle="default"
        className="auto-fill"
        type="button"
        onClick={this.copyBillingToShipping.bind(this)}
      >
        <em className="fa fa-edit" /><Translate value="auto_fill" />
      </Button>
    );
  }

  updateShipVia(e, Shipping, index) {
    let shippingInfo = this.props.shipping;
    if (shippingInfo && shippingInfo[index]) {
      shippingInfo[index].ShipVia = e.target.value;
    }
    this.setState({tempDisplay: shippingInfo});
    this.props.changeFieldArrayOfForm('Shipping', index, shippingInfo[index], 'customerForm');
  }

  renderAddress(Shipping, index) {
    return (
      <div>

        {isVAK && (this.props.selectedCompany || {value:''}).value == 6  ?
        <Row>
          <Col sm={8}>
            <div className="form-group">
              <label className="col-sm-2">
                <Translate value="name" />
              </label>
              <Field name={`${Shipping}.AddressName`} component={InputField} />
            </div>
          </Col>
          <Col sm={4}>
            <div className="form-group">
              <label className="col-sm-2">
                <Translate value="country" />
              </label>
              <Field
              name={`${Shipping}.Country`}
              matchPos="any"
              component={SelectionWithProps}
              options={countriesOptions}
              />
            </div>
          </Col>
        </Row>
        :
        <Row className="form-horizontal">
          <div className="form-group">
            <label className="col-sm-2">
              <Translate value="name" />
              {isESC && <span className="asteriksReq">*</span>}
            </label>
            <Col sm={10}>
              <Field name={`${Shipping}.AddressName`} component={InputField} />
            </Col>
          </div>
        </Row>}

        {
          isGGI && (
            <Row>
              <Col sm={4}>
                <div className="form-group">
                  <label><Translate value="title" /><span className="asteriksReq"></span></label>
                  <Field name={`${Shipping}.Title`} component={Selection} options={titleOptions} />
                </div>
              </Col>
              <Col sm={4}>
                <div className="form-group">
                  <label><Translate value="duty" /><span className="asteriksReq"></span></label>
                  <Field name={`${Shipping}.Duty`} component={Selection} options={dutyOptions} />
                </div>
              </Col>
              <Col sm={4}>
                <div className="form-group">
                  <label><Translate value="type" /><span className="asteriksReq"></span></label>
                  <Field name={`${Shipping}.Shipping_Type`} component={Selection} options={typeOptions} />
                </div>
              </Col>
            </Row>
          )
        }
        {
          isGGI && (
            <Row>
              <Col sm={4}>
                <div className="form-group">
                  <label><Translate value="deliver_date" /><span className="asteriksReq"></span></label>
                  <Field name={`${Shipping}.Deliver_Date`} component={InputField} />
                </div>
              </Col>
              <Col sm={4}>
                <div className="form-group">
                  <label><Translate value="deliver_start_time" /><span className="asteriksReq"></span></label>
                  <Field name={`${Shipping}.Deliver_Start`} component={Selection} options={timeOptions} />
                </div>
              </Col>
              <Col sm={4}>
                <div className="form-group">
                  <label><Translate value="deliver_end_time" /><span className="asteriksReq"></span></label>
                  <Field name={`${Shipping}.Deliver_End`} component={Selection} options={timeOptions} />
                </div>
              </Col>
              {/* <Col sm={4}>
                <div className="form-group">
                  <label><Translate value="duty" /><span className="asteriksReq"></span></label>
                  <Field name={`${Shipping}.Duty`} component={Selection} options={dutyOptions} />
                </div>
              </Col>
              <Col sm={4}>
                <div className="form-group">
                  <label><Translate value="type" /><span className="asteriksReq"></span></label>
                  <Field name={`${Shipping}.Type`} component={Selection} options={typeOptions} />
                </div>
              </Col> */}
            </Row>
          )
        }


        <Row>
          <Col sm={12}>
            <div className="form-group">
              <label>
                <Translate value="street" />
                {!isESC && <span className="asteriksReq">*</span>}
              </label>
              <Field name={`${Shipping}.Street`} component={InputField} />
            </div>
          </Col>
        </Row>

        {
          isSV &&
          <Row className="form-horizontal">
            <div className="form-group">
              <label className="col-sm-2"><Translate value="name_2" /></label>
              <Col sm={10}>
                <Field name={`${Shipping}.AddressName1`} component={InputField} />
              </Col>
            </div>
          </Row>
        }
        {
          isSV &&
          <Row>
          <Col sm={12}>
            <div className="form-group">
              <label><Translate value="street_2" /><span className="asteriksReq">*</span></label>
              <Field name={`${Shipping}.Street1`} component={InputField} />
            </div>
          </Col>
        </Row>
        }
        {
          isSV &&
          <Row>
            <Col sm={6}>
              <div className="form-group">
                <label><Translate value="discount" /></label>
                <Field name={`${Shipping}.Discount`} component={InputField} />
              </div>
            </Col>
            <Col sm={6}>
              <div className="form-group">
                <label><Translate value="ship_via" /></label>
                <input
                  list="browsers" name="browser" id="browser"
                  value={this.state.tempDisplay && this.state.tempDisplay[index] && this.state.tempDisplay[index].ShipVia}
                  onChange={(e) => {this.updateShipVia(e, Shipping, index)}}
                  style={{ width: '100%',height:'22px', borderRadius:'3px', border: '1px solid black' }}
                />
                <datalist id="browsers">
                  <option value="FEDEX (R)"/>
                  <option value="FEDEX GROUND"/>
                  <option value="FEDEX 3RD PARTY"/>
                  <option value="FEDEX COLLECT"/>
                  <option value="UPS GROUND"/>
                  <option value="UPS (R)"/>
                  <option value="UPS 3RD PARTY"/>
                  <option value="UPS COLLECT"/>
                  <option value="PARCEL POST"/>
                  <option value="PRIORITY MAIL"/>
                  <option value="TRUCKING"/>
                  <option value="PICK UP"/>
                  <option value="SEE ROUTING"/>
                  <option value="FREE FREIGHT"/>
                  <option value="CALL FOR INFO"/>
                  <option value="FREIGHT COLLECT"/>
                  <option value="POE"/>
                  <option value="FOB"/>
                </datalist>
                {/* <Field name={`${Shipping}.ShipVia`} component={InputField} /> */}
              </div>
            </Col>
          </Row>
        }

        {/* <Row className="form-horizontal">
          <div className="form-group">
            <label className="col-sm-2"><Translate value="street" /><span className="asteriksReq">*</span></label>
            <Col sm={10}>
              <Field name={`${Shipping}.Street`} component={InputField} />
            </Col>
          </div>
        </Row> */}

        <Row>
          <Col sm={6}>
            <div className="form-group">
              <label>
                <Translate value="city" />
                {!isESC && <span className="asteriksReq">*</span>}
              </label>
              <Field name={`${Shipping}.City`} component={InputField} />
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group">
              <label>
                <Translate value="state" />
                {!isESC && <span className="asteriksReq">*</span>}
              </label>
              <Field name={`${Shipping}.State`} component={InputField} />
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group">
              <label>
                <Translate value="zip" />
                {!isESC && <span className="asteriksReq">*</span>}
              </label>
              <Field name={`${Shipping}.Zip`} component={InputField} />
            </div>
          </Col>
        </Row>

        {
          isSV &&
          <Row>
            <Col sm={6}>
              <div className="form-group">
                <label><Translate value="country" /><span className="asteriksReq">*</span></label>
                <Field name={`${Shipping}.Country`} component={InputField} />
              </div>
            </Col>
          </Row>
        }
        <Row>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="first_name" /></label>
              <Field name={`${Shipping}.FirstName`} component={InputField} />
            </div>
          </Col>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="last_name" /></label>
              <Field name={`${Shipping}.LastName`} component={InputField} />
            </div>
          </Col>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="email" /></label>
              <Field name={`${Shipping}.Email`} component={InputField} />
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="tel" /></label>
              <Field name={`${Shipping}.Telephone`} component={InputField} />
            </div>
          </Col>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="cell_phone" /></label>
              <Field name={`${Shipping}.Cellphone`} component={InputField} />
            </div>
          </Col>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="fax" /></label>
              <Field name={`${Shipping}.Fax`} component={InputField} />
            </div>
          </Col>
          <Col sm={12}>
            <div className="form-group">
              <label><Translate value="note" /></label>
              <Field
                name={`${Shipping}.Note`}
                maxLength={150}
                component="Textarea"
                className="form-control"
                style={{ minHeight: '40px' }}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    const fields = this.props.fields;
    return (
      <div>
        <Button
          bsStyle="primary"
          className="plus"
          type="button"
          onClick={() => { fields.push({}); }} // pushes empty child field onto the end of the array
        >
          <em className="fa fa-plus" />
        </Button>

        {!fields.length && <div className="marginTopStyle" ><Translate value="no_shipping_information" /></div>}
        {
          fields.map((Shipping, index) =>
            <Row key={index}>
              <Col sm={12}>
                <div className="position-relative">
                  <h4><Translate value="shipping_poundsign" />{index + 1}</h4>
                  {index === 0 && this.renderAutoFillButton()}
                  {this.renderDeleteButton(index, fields)}
                </div>
                {this.renderAddress(Shipping, index)}
                <Field name={`${Shipping}.IsDefault`} component={renderIsDefault} />
              </Col>
            </Row>)
        }
      </div>
    );
  }
}

class renderContact extends Component {
  constructor() {
    super();
    this.state = {
      confirmOpen: false,
      agentModalOpen: false,
      ptModalOpen: false,
    }
  }

  componentDidMount() {
  }

  componentWillReceiveProps(nextProps) {
  }

  copyBillingToShipping(e) {
    e.preventDefault();
    const mainlingInfo = { ...this.props.billing, Type: 'Mailing' };
    const { mailing } = this.props;
    if (mailing && mailing.length > 0 && mailing[0]) {
      mainlingInfo.CustomerDetail_id = mailing[0].CustomerDetail_id;
    } else {
      delete mainlingInfo.CustomerDetail_id;
    }
    this.props.changeFieldArrayOfForm('Mailing', 0, mainlingInfo, 'customerForm');
  }

  renderDeleteButton(index, fields) {
    return (
      <Button
        bsStyle="danger"
        className="trash"
        type="reset"
        onClick={() => {
          fields.remove(index);
        }}
      >
        <em className="fa fa-trash-o" />
      </Button>
    );
  }

  renderAutoFillButton() {
    return (
      <Button
        bsStyle="default"
        className="auto-fill"
        type="button"
        onClick={this.copyBillingToShipping.bind(this)}
      >
        <em className="fa fa-edit" /><Translate value="auto_fill" />
      </Button>
    );
  }

  // renderAddress(Mainling, index) {
  //   return (
  //     <div>
  //       <Row className="form-horizontal">
  //         <div className="form-group">
  //           <label className="col-sm-2"><Translate value="name" /></label>
  //           <Col sm={10}>
  //             <Field name={`${Mainling}.AddressName`} component={InputField} />
  //           </Col>
  //         </div>
  //       </Row>
  //       {
  //         isGGI && (
  //           <Row>
  //             <Col sm={4}>
  //               <div className="form-group">
  //                 <label><Translate value="title" /><span className="asteriksReq"></span></label>
  //                 <Field name={`${Mainling}.Title`} component={Selection} options={titleOptions} />
  //               </div>
  //             </Col>
  //             <Col sm={4}>
  //               <div className="form-group">
  //                 <label><Translate value="duty" /><span className="asteriksReq"></span></label>
  //                 <Field name={`${Mainling}.Duty`} component={Selection} options={dutyOptions} />
  //               </div>
  //             </Col>
  //             <Col sm={4}>
  //               <div className="form-group">
  //                 <label><Translate value="type" /><span className="asteriksReq"></span></label>
  //                 <Field name={`${Mainling}.Shipping_Type`} component={Selection} options={typeOptions} />
  //               </div>
  //             </Col>
  //           </Row>
  //         )
  //       }
  //       {
  //         isGGI && (
  //           <Row>
  //             <Col sm={4}>
  //               <div className="form-group">
  //                 <label><Translate value="deliver_date" /><span className="asteriksReq"></span></label>
  //                 <Field name={`${Mainling}.Deliver_Date`} component={DatePicker} />
  //               </div>
  //             </Col>
  //             <Col sm={4}>
  //               <div className="form-group">
  //                 <label><Translate value="deliver_time" /><span className="asteriksReq"></span></label>
  //                 <Field name={`${Mainling}.Deliver_Time`} component={InputField} />
  //               </div>
  //             </Col>
  //             {/* <Col sm={4}>
  //               <div className="form-group">
  //                 <label><Translate value="duty" /><span className="asteriksReq"></span></label>
  //                 <Field name={`${Shipping}.Duty`} component={Selection} options={dutyOptions} />
  //               </div>
  //             </Col>
  //             <Col sm={4}>
  //               <div className="form-group">
  //                 <label><Translate value="type" /><span className="asteriksReq"></span></label>
  //                 <Field name={`${Shipping}.Type`} component={Selection} options={typeOptions} />
  //               </div>
  //             </Col> */}
  //           </Row>
  //         )
  //       }


  //       <Row>
  //         <Col sm={12}>
  //           <div className="form-group">
  //             <label><Translate value="street" /><span className="asteriksReq">*</span></label>
  //             <Field name={`${Mainling}.Street`} component={InputField} />
  //           </div>
  //         </Col>
  //       </Row>

  //       {/* <Row className="form-horizontal">
  //         <div className="form-group">
  //           <label className="col-sm-2"><Translate value="street" /><span className="asteriksReq">*</span></label>
  //           <Col sm={10}>
  //             <Field name={`${Shipping}.Street`} component={InputField} />
  //           </Col>
  //         </div>
  //       </Row> */}

  //       <Row>
  //         <Col sm={6}>
  //           <div className="form-group">
  //             <label><Translate value="city" /><span className="asteriksReq">*</span></label>
  //             <Field name={`${Mainling}.City`} component={InputField} />
  //           </div>
  //         </Col>
  //         <Col sm={3}>
  //           <div className="form-group">
  //             <label><Translate value="state" /><span className="asteriksReq">*</span></label>
  //             <Field name={`${Mainling}.State`} component={InputField} />
  //           </div>
  //         </Col>
  //         <Col sm={3}>
  //           <div className="form-group">
  //             <label><Translate value="zip" /><span className="asteriksReq">*</span></label>
  //             <Field name={`${Mainling}.Zip`} component={InputField} />
  //           </div>
  //         </Col>
  //       </Row>
  //       <Row>
  //         <Col sm={4}>
  //           <div className="form-group">
  //             <label><Translate value="first_name" /></label>
  //             <Field name={`${Mainling}.FirstName`} component={InputField} />
  //           </div>
  //         </Col>
  //         <Col sm={4}>
  //           <div className="form-group">
  //             <label><Translate value="last_name" /></label>
  //             <Field name={`${Mainling}.LastName`} component={InputField} />
  //           </div>
  //         </Col>
  //         <Col sm={4}>
  //           <div className="form-group">
  //             <label><Translate value="email" /></label>
  //             <Field name={`${Mainling}.Email`} component={InputField} />
  //           </div>
  //         </Col>
  //       </Row>
  //       <Row>
  //         <Col sm={4}>
  //           <div className="form-group">
  //             <label><Translate value="tel" /></label>
  //             <Field name={`${Mainling}.Telephone`} component={InputField} />
  //           </div>
  //         </Col>
  //         <Col sm={4}>
  //           <div className="form-group">
  //             <label><Translate value="alt_phone" /></label>
  //             <Field name={`${Mainling}.Cellphone`} component={InputField} />
  //           </div>
  //         </Col>
  //         <Col sm={4}>
  //           <div className="form-group">
  //             <label><Translate value="fax" /></label>
  //             <Field name={`${Mainling}.Fax`} component={InputField} />
  //           </div>
  //         </Col>
  //         <Col sm={12}>
  //           <div className="form-group">
  //             <label><Translate value="note" /></label>
  //             <Field
  //               name={`${Mainling}.Note`}
  //               maxLength={150}
  //               component="Textarea"
  //               className="form-control"
  //               style={{ minHeight: '40px' }}
  //             />
  //           </div>
  //         </Col>
  //       </Row>
  //     </div>
  //   );
  // }

  renderAddress = (Mailing, index) => {
    return (
      <div>
        <Row className="form-horizontal">
          <div className="form-group">
            <label className="col-sm-2"><Translate value="name" /></label>
            <Col sm={12}>
              <Field name={`${Mailing}.AddressName`} component={InputField} />
            </Col>
            {/* <Col sm={4}>
              <Button
                bsStyle="default"
                className="auto-fill"
                type="button"
                onClick={this.copyBillingToMailing.bind(this)}
              >
                <em className="fa fa-edit" /><Translate value="auto_fill" />
              </Button>
            </Col> */}
          </div>
        </Row>
        <Row>
          <Col sm={6}>
            <div className="form-group">
              <label><Translate value="street" /><span className="asteriksReq">*</span></label>
              <Field name={`${Mailing}.Street`} component={InputField} />
            </div>
          </Col>

          {
            isGGI && (
              <Col sm={3}>
                <div className="form-group">
                  <label><Translate value="title" /><span className="asteriksReq"></span></label>
                  <Field name={`${Mailing}.Title`} component={Selection} options={titleOptions} />
                </div>
              </Col>
            )
          }
          {
            isGGI && (
              <Col sm={3}>
                <div className="form-group">
                  <label><Translate value="duty" /><span className="asteriksReq"></span></label>
                  <Field name={`${Mailing}.Duty`} component={Selection} options={dutyOptions} />
                </div>
              </Col>
            )
          }

        </Row>
        <Row>
          <Col sm={6}>
            <div className="form-group">
              <label><Translate value="city" /><span className="asteriksReq">*</span></label>
              <Field name={`${Mailing}.City`} component={InputField} />
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group">
              <label><Translate value="state" /><span className="asteriksReq">*</span></label>
              <Field name={`${Mailing}.State`} component={InputField} />
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group">
              <label><Translate value="zip" /><span className="asteriksReq">*</span></label>
              <Field name={`${Mailing}.Zip`} component={InputField} />
            </div>
          </Col>
        </Row>

        {/* <h3><Translate value="contact_information" /></h3> */}
        <Row>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="first_name" /></label>
              <Field name={`${Mailing}.FirstName`} component={InputField} />
            </div>
          </Col>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="last_name" /></label>
              <Field name={`${Mailing}.LastName`} component={InputField} />
            </div>
          </Col>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="email" /></label>
              <Field name={`${Mailing}.Email`} component={InputField} />
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="tel" /></label>
              <Field name={`${Mailing}.Telephone`} component={InputField} />
            </div>
          </Col>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="cell_phone" /></label>
              <Field name={`${Mailing}.Cellphone`} component={InputField} />
            </div>
          </Col>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="fax" /></label>
              <Field name={`${Mailing}.Fax`} component={InputField} />
            </div>
          </Col>
        </Row>
      </div>
    )
  }

  render() {
    const fields = this.props.fields;
    return (
      <div>
        <Button
          bsStyle="primary"
          className="plus"
          type="button"
          onClick={() => { fields.push({}); }} // pushes empty child field onto the end of the array
        >
          <em className="fa fa-plus" />
        </Button>

        {!fields.length && <div className="marginTopStyle" ><Translate value="no_contact_information" /></div>}
        {
          fields.map((Mainling, index) =>
            <Row key={index}>
              <Col sm={12}>
                <div className="position-relative">
                  <h4><Translate value="contact_poundsign" />{index + 1}</h4>
                  {index === 0 && this.renderAutoFillButton()}
                  {this.renderDeleteButton(index, fields)}
                </div>
                {this.renderAddress(Mainling, index)}
                {/* <Field name={`${Mainling}.IsDefault`} component={renderIsDefault} /> */}
              </Col>
            </Row>)
        }
      </div>
    );
  }
}

class CustomerForm extends Component {
  static contextTypes = {
    router: React.PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      dirty: false,
      case: 'paymentTermMissing',
      businessType: '',
      creditStatus: 'Good',
      rating: '',
      orderType: '',
      IsStripe: false,
      customerOptions: [],
      rows: [],
      filters: {},
      Sub_Customer_id: "",
      fjCustomerId: "",
      is_already_binding: false,
      isCompaniesCheckedVisible: false,
      companies:[],
    };
    this.openConfirm = this.openConfirm.bind(this);
    this.closeConfirm = this.closeConfirm.bind(this);
    this.openAgentModal = this.openAgentModal.bind(this);
    this.closeAgentModal = this.closeAgentModal.bind(this);
    this.openPTModal = this.openPTModal.bind(this);
    this.closePTModal = this.closePTModal.bind(this);
    this.closeCompanies = this.closeCompanies.bind(this);
    this.getAutoCustomerNumber = this.getAutoCustomerNumber.bind(this);
  }

  componentWillMount() {
    reset('customerForm');
  }

  // Deal with the preload of data.
  componentDidMount() {
    this.getAutoCustomerNumber()
    if(isGGI || isVAK) {
      this.props.fetchBaseUsers(true, true);
    } else {
      this.props.fetchBaseUsers(false, true);
    }
    this.props.fetchCustomers()
      .then(() => {
        this.getCustomerOptions();
      })
    const { currentCustomer } = this.props;
    if (currentCustomer) {
      this.setState({ fjCustomerId: currentCustomer.Customer_id });
      this.props.fetchCustomerDetail(currentCustomer.Customer_id)
        .then(() => this.props.fetchPaymentTerms());
    } else {
      this.props.fetchPaymentTerms();
      this.props.setDefaultOfForm('PriceLevel', '5', 'customerForm');
      this.props.setDefaultOfForm('IsWholesale', 'false', 'customerForm');
      this.props.setDefaultOfForm('IsShowPrice', 'true', 'customerForm');
      this.props.setDefaultOfForm('IsActive', 'true', 'customerForm');
      this.props.setDefaultOfForm('IsPrtReminder', 'false', 'customerForm');
      this.props.setDefaultOfForm('IsPrtGeneralInfor', 'false', 'customerForm');
      this.props.setDefaultOfForm('IsInternal', 'false', 'customerForm');
      this.props.setDefaultOfForm('HasCRV', 'false', 'customerForm');
      this.props.setDefaultOfForm('IsEmailInvoice', 'false', 'customerForm');
      var currentDate = new Date();
      this.props.setDefaultOfForm('StartDate', currentDate, 'customerForm');
      this.props.setDefaultOfForm('CreateDate', currentDate, 'customerForm');

      if (isOCM) {
        this.props.setDefaultOfForm('PriceLevel', '1', 'customerForm');
      }
      if(isVAK) {
        this.props.setDefaultOfForm('QuickbookAccount', 'VK', 'customerForm');
      }
    }
    // this.props.fetchDefaultBuyers();

    // making a leaving hook to confirm leaving
    this.props.router.setRouteLeaveHook(this.props.route, this.routerWillLeave.bind(this));
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.dirty !== this.props.dirty) {
      this.setState({
        dirty: nextProps.dirty
      });
    }
    if(isVAK && nextProps.selectedCompany != this.props.selectedCompany && (nextProps.selectedCompany || {value:''}).value && this.props.companySelection) {
      let companies = [];
      this.props.companySelection.map(item => {
        if(item.value != nextProps.selectedCompany.value) {
          companies.push({...item});
        }
      })
      this.setState({
        companies,
      });
    }
    if(isVAK && nextProps.companySelection && nextProps.companySelection != this.props.companySelection && (this.props.selectedCompany || {value:''}).value) {
      let companies = [];
      nextProps.companySelection.map(item => {
        if(item.value != this.props.selectedCompany.value) {
          companies.push({...item});
        }
      })
      this.setState({
        companies,
      });
    }
    // if((nextProps.isActive === true || nextProps.isActive === "true") && nextProps.isActive != this.props.isActive) {
    //   if(!this.props.paymentTerm_id && !nextProps.paymentTerm_id) {
    //     this.props.setDefaultOfForm('IsActive', "false", 'customerForm');
    //     this.openConfirm();
    //   }
    // }
    if (nextProps.paymentTerm_id != this.props.paymentTerm_id) {
      if (!nextProps.paymentTerm_id || nextProps.paymentTerm_id.length === 0) {
        this.props.setDefaultOfForm('IsActive', 'true', 'customerForm');
        this.props.setDefaultOfForm('PaymentTerm_id', null, 'customerForm');
        this.openConfirm();
      }
    }
    if (nextProps.currentCustomerDetail && nextProps.currentCustomerDetail !== this.props.currentCustomerDetail) {
      const {
        BusinessType, CreditStatus, OrderType, IsStripe, Attachment1, Attachment2, Attachment3,
        Attachment4, Attachment5, Attachment6, Attachment7, Attachment8, AttachmentName1, AttachmentName2, AttachmentName3,
        AttachmentName4, AttachmentName5, AttachmentName6, AttachmentName7, AttachmentName8, is_already_binding = false } = nextProps.currentCustomerDetail;
      this.setState({
        Attachment1,
        Attachment2,
        Attachment3,
        Attachment4,
        Attachment5,
        Attachment6,
        Attachment7,
        Attachment8,
        AttachmentName1,
        AttachmentName2,
        AttachmentName3,
        AttachmentName4,
        AttachmentName5,
        AttachmentName6,
        AttachmentName7,
        AttachmentName8,
        is_already_binding,
      });
      if (BusinessType) {
        this.setState({ businessType: BusinessType });
      }
      if (CreditStatus) {
        this.setState({ creditStatus: CreditStatus });
      }
      if (OrderType) {
        this.setState({ orderType: OrderType });
      }
      if (IsStripe) {
        this.setState({ IsStripe: true });
      } else {
        this.setState({ IsStripe: false });
      }
    }
    if (nextProps.currentCustomerDetail && nextProps.currentCustomerDetail !== this.props.currentCustomerDetail && nextProps.currentCustomerDetail.Sub_Customer_id) {
      this.formatCustomerInput(nextProps.currentCustomerDetail.Sub_Customer_id);
    }

    if (isSV) {
      const sales = this.getUsers();
      if (nextProps.Sales_User_id && nextProps.Sales_User_id.value && nextProps.Sales_User_id !== this.props.Sales_User_id) {
        const rate = sales.filter(s => s.value === nextProps.Sales_User_id.value);
        let commission =  rate.length > 0 ? rate[0].commission : '';
        this.props.setDefaultOfForm('Commission', commission, 'customerForm');
      } else if (nextProps.Sales_User_id=== null) {
        this.props.setDefaultOfForm('Commission', null, 'customerForm');
      }
      if (nextProps.Sales_User_id2 && nextProps.Sales_User_id2.value && nextProps.Sales_User_id2 !== this.props.Sales_User_id2) {
        const rate2 = sales.filter(s => s.value === nextProps.Sales_User_id2.value);
        let commission2 =  rate2.length > 0 ? rate2[0].commission : '';
        this.props.setDefaultOfForm('Commission2', commission2, 'customerForm');
      } else if (nextProps.Sales_User_id2 === null) {
        this.props.setDefaultOfForm('Commission2', null, 'customerForm');
      }
    }

    if (isSV && nextProps.paymentTerm_id != this.props.paymentTerm_id) {
      if (!nextProps.paymentTerm_id || nextProps.paymentTerm_id.length === 0) {
        this.props.setDefaultOfForm('IsActive', 'true', 'customerForm');
        this.props.setDefaultOfForm('PaymentTerm_id', null, 'customerForm');
        this.openConfirm();
      }
    }

    this.getAutoCustomerNumber(nextProps)
  }

  componentDidUpdate(prevProps) {
    this.getAutoCustomerNumber(prevProps)
    reset('customerForm');
  }

  routerWillLeave(nextLocation) {
    if (this.state.dirty) return <Translate value="work_not_saved_warning" />
  }

  handleFormSubmit(formProps) {
    this.formatCustomerOutput();
    this.setState({ dirty: false });
    this.checkPermission('change_customer');
    if (!formProps.Billing) {
      formProps.Billing = {};
      formProps.Billing.AddressName = formProps.Name;
    }
    if (!formProps.Mailing) {
      formProps.Mailing = {};
      formProps.Mailing.AddressName = formProps.Name;
    }
    if(isVAK){
      delete formProps.CustomerNum;
    }
    if (!this.props.currentCustomer) {
      this.props.createCustomer(formProps, this.state);
    } else {
      if (!this.checkPermission("change_customer")) {
        this.props.editCustomer(formProps, this.state);
      } else {
        alert("You have no permission!");
      }
    }
  }

  openConfirm() {
    this.setState({ confirmOpen: true });
  }

  closeConfirm() {
    this.setState({ confirmOpen: false });
  }

  openAgentModal() {
    this.setState({ agentModalOpen: true });
  }
  closeAgentModal() {
    this.setState({ agentModalOpen: false });
  }

  openPTModal() {
    this.setState({ ptModalOpen: true });
  }
  closePTModal() {
    this.setState({ ptModalOpen: false });
  }
  closeCompanies() {
    this.setState({ isCompaniesCheckedVisible: false });
  }

  getAutoCustomerNumber(newProps) {
    if (!isESC || this.props.route.path !== 'customers/new') {
      return
    }
    if (newProps && this.props.selectedCompany === newProps.selectedCompany) {
      return
    }
    this.props.getAutoCustomerNumber(value => {
      this.props.setDefaultOfForm('CustomerNum', value, 'customerForm');
    })
  }

  breadcrumb() {
    if (!this.props.params.id) {
      return (
        <Breadcrumb>
          <Breadcrumb.Item>
            <Translate value="general_management" />
          </Breadcrumb.Item>
          <Breadcrumb.Item active="true">
            <Translate value="create_customer" />
          </Breadcrumb.Item>
        </Breadcrumb>
      );
    }
    return (
      <Breadcrumb>
        <Breadcrumb.Item>
          <Translate value="general_management" />
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          <Translate value="customers" />
        </Breadcrumb.Item>
        <Breadcrumb.Item active="true">
          <Translate value="edit_customer" />
        </Breadcrumb.Item>
      </Breadcrumb>
    );
  }

  renderPaymentTerms() {
    if (this.props.paymentTermsIsLoading) { return <Spinner />; } // If group is loading, show a spinner.
    let paymentTermOptions = this.getPaymentTermOptions();
    return (
      <div>
        <Field name="PaymentTerm_id" matchPos="any" component={Selection} options={paymentTermOptions} />
      </div>
    )
  }

  getPaymentTermOptions() {
    var paymentTermOptions = [];
    this.props.paymentTerms.map(paymentTerm => {
      paymentTermOptions.push({ value: paymentTerm.PaymentTerm_id, label: paymentTerm.Name })
    });
    // if ()
    return paymentTermOptions;
  }

  copyBillingToMailing(e) {
    e.preventDefault();
    if (this.props.billing) {
      const mailingInfo = { ...this.props.billing, Type: 'Mailing' };
      delete mailingInfo.CustomerDetail_id;
      this.props.setDefaultOfForm('Mailing', mailingInfo, 'customerForm');
    }
  }

  copyToBilling(e) {
    e.preventDefault();
    let billingInfo = {};
    if (this.props.Name) {
      billingInfo = { ...this.props.billing, AddressName: this.props.Name, Type: 'Billing' };
      this.props.setDefaultOfForm('Billing', billingInfo, 'customerForm');
    }
  }

  checkPermission(permission) {
    return false;
  }

  getDefaultBuyerOptions() {
    const salesUserOptions = [];
    (this.props.defaultBuyers || []).forEach((defaultBuyer) => {
      salesUserOptions.push({
        value: defaultBuyer.BaseUser_id,
        label: defaultBuyer.username,
      });
    });
    return salesUserOptions;
  }

  renderDefaultSales() {
    const defaultBuyerOptions = this.getUsers();
    return (
      <Field name="Sales_User_id" component={Selection} options={defaultBuyerOptions} />
    );
  }

  renderDefaultSales2() {
    const defaultBuyerOptions = this.getUsers();
    return (
      <Field name="Sales_User_id2" component={Selection} options={defaultBuyerOptions} />
    );
  }

  renderCompany() {
    let companyOptions = [];
    this.props.companySelection.map((company) => {
      companyOptions.push({ label: company.Name, value: company.id });
    });

    return (
      <Field name="AssociatedCompany" component={Selection} options={this.props.companySelection} />
    );
  }

  getCustomerOptions() {
    let customerOptions = [];
    this.props.customers.map((customer) => {
      customerOptions.push({ value: customer.Customer_id, label: customer.Name, customer_num: customer.CustomerNum });
    });
    this.setState({ customerOptions });
  }

  setCustomer = (e) => {
    let { rows } = this.state;
    let duplicate = false;
    for (let i = 0; i < rows.length; i++) {
      if (e && e.value && rows[i].customer_id === e.value) {
        duplicate = true;
        return;
      }
    }
    if (e && e.value && duplicate === false) {
      rows.push({ customer_id: e.value, customer_name: e.label, customer_num: e.customer_num });
    }
    this.setState({ rows });
  }

  removeCustomer(customer_id) {
    let { rows } = this.state;
    rows = rows.filter((obj) => {
      const match = obj.customer_id !== customer_id;
      return match;
    });
    this.setState({ rows });
  }

  formatCustomerInput(inputString) {
    let stringArray = [];
    let line = null;
    let output = [];

    stringArray = inputString.split(',');
    stringArray.map(a => {
      if (a.split(':')[1]) {
        line = { customer_id: a.split(':')[0], customer_name: a.split(':')[1].split(';')[0], customer_num: a.split(':')[1].split(';')[1] };
        output.push(line);
      }
    });
    this.setState({ rows: output });
  }

  formatCustomerOutput() {
    let { rows } = this.state;
    let outputString = "";
    if (rows && rows.length > 0) {
      rows.map(r => {
        outputString += r.customer_id + ":" + r.customer_name + ";" + r.customer_num + ",";
      });
      outputString = outputString.slice(0, -1);
    }
    this.state.Sub_Customer_id = outputString;
  }

  onAttachmentDrop = (files, field, name) => {
    const formData = new FormData();
    formData.append('File', files[0]);
    const success = (data) => {
      this.setState({
        [field]: data.URL || data,
        [name]: data.fileName,
      })
    }
    getImageUrl(formData, success);
  }

  renderAttachmentDrop = (field, name) => {
    return (
      <Dropzone
        onDrop={(e) => {
          if (!this.state[field]) {
            this.onAttachmentDrop(e, field, name)
          }
        }}
        accept="image/*,.pdf"
        disableClick={this.state[field]}
      >
        <div style={{
          height: '100%',
          display: 'grid',
          placeItems: 'center',
        }}>
          {
            this.state[field] ? <div>
              <span
                onClick={(e) => {
                  e.stopPropagation();
                  this.setState({
                    [field]: '',
                    [name]: '',
                  })
                }}
                style={{
                  position: 'absolute',
                  top: '0px',
                  right: '17px',
                  color: 'red',
                  fontSize: '17px',
                  fontWeight: 'bolder',
                  cursor: 'pointer'
                }}>X</span>
              {
                this.state[field].slice(-3) === 'pdf' ?
                (
                  <a style={{ display: 'block', textAlign: 'center' }} href={this.state[field]} onClick={e => e.stopPropagation()}><Translate value="download_PDF" /></a>
                ) : (
                  <div style={{ width: '100%', height: "80%" }}><a href={this.state[field]}><img src={this.state[field]} style={{ width: '100%', height: '180px', objectFit: 'fill' }}/></a></div>
                )
              }
              <span style={{ display: 'block', width: '180px', whiteSpace: 'pre-wrap', overflowWrap: 'break-word', textAlign: 'center' }}>
                {this.state[name]}
              </span>
            </div> : <span><Translate value="attachment" /></span>
          }
        </div>
      </Dropzone>
    )
  }

  getUsers() {
    if (isOCM) {
      return this.props.users.map((user) => ({
        label: user.username,
        value: user.user_id
      }));
    }

    if (isSV) {
      return this.props.users.map((user) => ({
        label: user.FirstName,
        value: user.user_id,
        commission: user.Commission
      }));
    }

    return this.props.users.map((user) => ({ value: user.user_id, label: user.FirstName }));
  }

  renderMailingDetails = () => {
    if (isGGI) return null;
    const mailingDetails = <h2><Translate value="mailing_details" /></h2>

    return (
    <Panel id="mailing-details" style={{height: isSV ? '580px' : '490px'}}header={mailingDetails}>
         {
                    isSV &&
                  <Row className="form-horizontal">
                    <div className="form-group">
                      <label className="col-sm-2"><Translate value="title" /></label>
                      <div className="col-sm-10">
                        <Field name="Mailing.Title" component={InputField} />
                      </div>
                    </div>
                  </Row>
  }
      <Row className="form-horizontal">
        <div className="form-group">
          <label className="col-sm-2">
            <Translate value="name" />
            {isESC && <span className="asteriksReq">*</span>}
          </label>
          <Col sm={6}>
            <Field name="Mailing.AddressName" component={InputField} />
          </Col>
          <Col sm={4}>
            <Button
              bsStyle="default"
              className="auto-fill"
              type="button"
              onClick={this.copyBillingToMailing.bind(this)}
            >
              <em className="fa fa-edit" /><Translate value="auto_fill" />
            </Button>
          </Col>
        </div>
      </Row>
      <Row>
        <Col sm={isSV ? 12 : 6}>
          <div className="form-group">
            <label>
              <Translate value="street" />
              {!(isESC || isVAK) && <span className="asteriksReq">*</span>}
            </label>
            <Field name="Mailing.Street" component={InputField} />
          </div>
        </Col>
        {
          isVAK && (this.props.selectedCompany || {value: ''}).value == 6 &&
          <Col sm={3}>
            <div className="form-group">
              <label><Translate value="country" /></label>
              <Field name="Mailing.Country"
              matchPos="any"
              component={SelectionWithProps}
              options={countriesOptions} />
            </div>
          </Col>
        }

          {
            isGGI && (
              <Col sm={3}>
                <div className="form-group">
                  <label><Translate value="title" /><span className="asteriksReq"></span></label>
                  <Field name={`Mailing.Title`} component={Selection} options={titleOptions} />
                </div>
              </Col>
            )
          }
          {
            isGGI && (
              <Col sm={3}>
                <div className="form-group">
                  <label><Translate value="duty" /><span className="asteriksReq"></span></label>
                  <Field name={`Mailing.Duty`} component={Selection} options={dutyOptions} />
                </div>
              </Col>
            )
          }
        </Row>

        {
          isSV &&
          <Row className="form-horizontal">
            <div className="form-group">
              <label className="col-sm-2"><Translate value="name_2" /></label>
              <Col sm={6}>
                <Field name="Mailing.AddressName1" component={InputField} />
              </Col>
            </div>
          </Row>
        }
        {
          isSV &&
          <Row>
            <Col sm={12}>
              <div className="form-group">
                <label><Translate value="street_2" /><span className="asteriksReq">*</span></label>
                <Field name="Mailing.Street1" component={InputField} />
              </div>
            </Col>
          </Row>
        }
        <Row>
          <Col sm={6}>
            <div className="form-group">
              <label>
                <Translate value="city" />
                {!(isESC || isVAK) && <span className="asteriksReq">*</span>}
              </label>
              <Field name="Mailing.City" component={InputField} />
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group">
              <label>
                <Translate value="state" />
                {!(isESC || isVAK) && <span className="asteriksReq">*</span>}
              </label>
              <Field name="Mailing.State" component={InputField} />
            </div>
          </Col>
          <Col sm={3}>
            <div className="form-group">
              <label>
                <Translate value="zip" />
                {!(isESC || isVAK) && <span className="asteriksReq">*</span>}
              </label>
              <Field name="Mailing.Zip" component={InputField} />
            </div>
          </Col>
        </Row>
        {
          isSV &&
          <Row>
            <Col sm={6}>
              <div className="form-group">
                <label><Translate value="country" /><span className="asteriksReq">*</span></label>
                <Field name="Mailing.Country" component={InputField} />
              </div>
            </Col>
          </Row>
        }
        {/* <h3><Translate value="contact_information" /></h3> */}
        <Row>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="first_name" /></label>
              <Field name="Mailing.FirstName" component={InputField} />
            </div>
          </Col>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="last_name" /></label>
              <Field name="Mailing.LastName" component={InputField} />
            </div>
          </Col>
          {!(isLAP || isAPD) &&
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="email" /></label>
              <Field name="Mailing.Email" component={InputField} />
            </div>
          </Col>
  }
        </Row>
        <Row>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="tel" /></label>
              <Field name="Mailing.Telephone" component={InputField} />
            </div>
          </Col>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="cell_phone" /></label>
              <Field name="Mailing.Cellphone" component={InputField} />
            </div>
          </Col>
          <Col sm={4}>
            <div className="form-group">
              <label><Translate value="fax" /></label>
              <Field name="Mailing.Fax" component={InputField} />
            </div>
          </Col>
        </Row>
        {(isLAP || isAPD) &&
         <Row>
         <Col sm={11}>
           <div className="form-group">
             <label><Translate value="email" /></label>
             <Field
               name="Mailing.Email"
               component="Textarea"
               className="form-control resize-vertical"
               style={{ minHeight: '40px' }}
               resize="vertical"
             />
           </div>
         </Col>
       </Row>
        }
      </Panel>
    )
  }

  renderMailingDetailsGGI = () => {
    if (!isGGI) return null;
    const mailingDetails = <h2><Translate value="contact_details" /></h2>;

    return (
      <Panel id="shipping-details" header={mailingDetails}>
        <h3><Translate value="contacts" /></h3>
        <FieldArray
          name="Mailing"
          component={renderContact}
          billing={this.props.billing}
          mailing={this.props.mailing} // {this.props.billingAddress}
          changeFieldArrayOfForm={this.props.changeFieldArrayOfForm}
        />
      </Panel>
    );
  }

  isCustomerNumDisabled = () => {
    if (isGGI) {
      if (this.props.currentCustomerDetail && this.props.currentCustomerDetail.CustomerNum) {
        return true;
      }
      return false;
    }
    return false;
  }

  renderLastOrderDate = () => {
    if (!isGGI) return null;
    return <Col sm={6}>
      <div className="form-group">
        <label><Translate value="last_order_date" /></label>
        <Field name="LastOrderDate" component={DatePicker} disabled/>
      </div>
    </Col>
  }

  renderHasCRV = () => {
    // if (!isOCM) return null;
    if (isESC) return null;
    return <Field name="HasCRV" component={renderRadios} paymentTerm_id={this.props.paymentTerm_id} setDefaultOfForm={this.props.setDefaultOfForm} />
  }

  renderSharedCompany = () => {
    if (!isVAK || (this.props.selectedCompany || {value:''}).value != 6) return null;
    return <Field name="QuickbookAccount" component={renderRadios} Company_id={this.props.Company_id} selectedCompany={this.props.selectedCompany}/>
  }

  renderEmailInvoice = () => {
    if (!(isLAP || isAPD)) return null;
    return <Field name="IsEmailInvoice" component={renderRadios} paymentTerm_id={this.props.paymentTerm_id} setDefaultOfForm={this.props.setDefaultOfForm} />
  }

  renderAttach = () => {
    if(isGGI) {
      return <Panel id="attachment-panel" header={<h2><Translate value='customer_attachments'/></h2> }>
      <Row>
        <Col xs={3}>
          {this.renderAttachmentDrop('Attachment1','AttachmentName1')}
        </Col>
        <Col xs={3}>
          {this.renderAttachmentDrop('Attachment2','AttachmentName2')}
        </Col>
        <Col xs={3}>
          {this.renderAttachmentDrop('Attachment3','AttachmentName3')}
        </Col>
      </Row>
      <Row style={{ marginTop: '5px' }}>
        <Col xs={3}>
          {this.renderAttachmentDrop('Attachment4','AttachmentName4')}
        </Col>
        <Col xs={3}>
          {this.renderAttachmentDrop('Attachment5','AttachmentName5')}
        </Col>
      </Row>
    </Panel>
    }
    return <Panel id="attachment-panel" header={<h2><Translate value='customer_attachments'/></h2> }>
    <Row>
      <Col xs={3}>
        {this.renderAttachmentDrop('Attachment1','AttachmentName1')}
      </Col>
      <Col xs={3}>
        {this.renderAttachmentDrop('Attachment2','AttachmentName2')}
      </Col>
      <Col xs={3}>
        {this.renderAttachmentDrop('Attachment3','AttachmentName3')}
      </Col>
      <Col xs={3}>
        {this.renderAttachmentDrop('Attachment4','AttachmentName4')}
      </Col>
    </Row>
    <Row style={{ marginTop: '5px' }}>
      <Col xs={3}>
        {this.renderAttachmentDrop('Attachment5','AttachmentName5')}
      </Col>
      <Col xs={3}>
        {this.renderAttachmentDrop('Attachment6','AttachmentName6')}
      </Col>
      <Col xs={3}>
        {this.renderAttachmentDrop('Attachment7','AttachmentName7')}
      </Col>
      <Col xs={3}>
        {this.renderAttachmentDrop('Attachment8','AttachmentName8')}
      </Col>
    </Row>
  </Panel>
  }

  render() {
    const { customerOptions, customerTableData } = this.state;
    const that = this;
    const customerDetails = (<h2><Translate value="customer_details" /></h2>);
    const billingDetails = (<h2><Translate value="billing_details" /></h2>);
    const mailingDetails = isGGI ? (<h2><Translate value="contact_details" /></h2>) : (<h2><Translate value="mailing_details" /></h2>);
    const shippingDetails = (<h2><Translate value="shipping_details" /></h2>);
    const customerLink = (<h2><Translate value="customer_link" /></h2>);
    const emails = (<h2><Translate value={isOLG ? "app_email_phone" : "app_email"} /></h2>);
    const confirmAction = (<Translate value="confirm_action" />);
    const agentAction = (<Translate value="agents" />);
    const priceTable = (<Translate value="price_table" />);
    const { handleSubmit, submitting, pristine, isCreating, isEditing, Company_id, selectedCompany } = this.props;
    const vakSave = isVAK && Company_id && Company_id != (selectedCompany || {value: ''}).value;
    const createDialogStyle = {
      height: '600px',
      marginTop: '-20%',
      width: '680px',
      marginLeft: '-10%',
      left: '45%',
    };
    const createDialogStyle2 = {
      height: '600px',
      marginTop: '-20%',
      width: '600px',
      marginLeft: '-10%',
      left: '45%',
    };
    const createDialogStylePT = {
      height: '600px',
      marginTop: '-20%',
      width: '600px',
      marginLeft: '-10%',
      left: '45%',
    };
    const createDialogStyleDup = {
      height: '400px',
      marginTop: '-20%',
      width: '600px',
      marginLeft: '-10%',
      left: '45%',
    };

    let businessTypeOptions = [
      { label: <Translate value="supermarket" />, value: 'Supermarket' },
      { label: <Translate value="foodWholesale" />, value: 'Food Wholesale' },
      { label: <Translate value="wholesale" />, value: 'Wholesale' },
      { label: <Translate value="pharmacy" />, value: 'Pharmacy' },
      { label: <Translate value="restaurant" />, value: 'Restaurant' },
      { label: <Translate value="bakery" />, value: 'Bakery' },
      { label: <Translate value="ecommerce" />, value: 'Ecommerce' },
      { label: <Translate value="wechatBusiness" />, value: 'Wechat Business' },
    ];
    if (isSW) {
      businessTypeOptions = [
        { label: <Translate value="individual" />, value: 'Individual' },
        { label: <Translate value="convenienceStore" />, value: 'Convenience Store' },
        { label: <Translate value="retailer" />, value: 'Retailer' },
        { label: <Translate value="restaurant" />, value: 'Restaurant' },
        { label: <Translate value="manufacturer" />, value: 'Manufacturer' },
        { label: <Translate value="wholesalerDistributor" />, value: 'Wholesaler / Distributor' },
        { label: <Translate value="others" />, value: 'Others' },
      ]
    }
    if (isHMM) {
      businessTypeOptions = [
        { label: <Translate value="contractor" />, value: 'Contractor' },
        { label: <Translate value="builder" />, value: 'Builder' },
        { label: <Translate value="retailStore" />, value: 'Retail Store' },
        { label: <Translate value="wholesaleStore" />, value: 'Wholesale Store' },
      ]
    }
    if (isGGI) {
      businessTypeOptions = [
        { label: <Translate value="1_wholesale_distributor_WH" />, value: 'Wholesale Distributor', num: 1, abbr: "WH" },
        { label: <Translate value="2_asia_supermarket_AS" />, value: 'Asia Supermarket', num: 2, abbr: 'AS' },
        { label: <Translate value="3_restaurant_RE" />, value: 'Restaurant', num: 3, abbr: 'RE' },
        { label: <Translate value="4_broker_trader_import_BK" />, value: 'Broker Trader Import', num: 4, abbr: 'BK' },
        { label: <Translate value="5_processor_prison_military_airline_school_club_PS" />, value: 'Processor Prison Military Airline School Club', num: 5, abbr: 'PS' },
        { label: <Translate value="6_none_asian_supermarket_NS" />, value: 'None Asian Supermarket', num: 6, abbr: 'NS' },
        { label: <Translate value="7_online_order_OO" />, value: 'Online Order', num: 7, abbr: 'OO' },
        { label: <Translate value="8_cash_carry_CC" />, value: 'Cash Carry', num: 8, abbr: 'CC' },
        { label: <Translate value="9_other_OT" />, value: 'Other', num: 9, abbr: 'OT' },
        { label: <Translate value="0_VIP_VP" />, value: 'VIP', num: 0, abbr:  "VP" },
      ]
    }
    if (isEKC || isLMH || isBRO || isSDR || isCRW || isSC) {
      businessTypeOptions = [
        { label: <Translate value="wholesale" />, value: 'Wholesale' },
        { label: <Translate value="retail" />, value: 'Retail' },
        { label: <Translate value="construction" />, value: 'Construction' },
      ]
    }
    if(isVAK) {
      businessTypeOptions = [
        { label: <Translate value="dental_office" />, value: 'Supermarket' },
        { label: "DSO", value: 'Dental Office' },
        { label: <Translate value="resident" />, value: 'Resident' },
        { label: <Translate value="university" />, value: 'University' },
        { label: <Translate value="supermarket" />, value: 'Supermarket' },
        { label: <Translate value="wholesale" />, value: 'Wholesale' },
        { label: <Translate value="pharmacy" />, value: 'Pharmacy' },
        { label: <Translate value="ecommerce" />, value: 'Ecommerce' },
        { label: <Translate value="wechatBusiness" />, value: 'Wechat Business' },
      ];
    }

    const creditOptions = [
      { label: 'Good', value: 'Good' },
      { label: 'Bad', value: 'Bad' },
      { label: 'COD', value: 'COD' },
    ];

    const ratingOptions = [
      { label: 'Gold', value: 'Gold' },
      { label: 'Silver', value: 'Silver' },
      { label: 'Bronze', value: 'Bronze' },
    ];

    const orderTypeOptions = [
      { label: 'Preset', value: 'Preset' },
      { label: 'Text', value: 'Text' },
      { label: 'Call', value: 'Call' },
      { label: 'Email', value: 'Email' },
      { label: 'Online', value: 'Online' },
    ];

    const paymentMethodOptions = [
      { label: 'Anywhere', value: false },
      { label: 'Stripe', value: true },
    ];

    const delFormatter = React.createClass({
      render() {
        return (
          <span>
            <Button
              bsStyle="danger"
              className="textAlignStyle"
              style={{ height: '23px', width: '39px', padding: '0px' }}
              onClick={() => {
                // const ProductNum = this.props.dependentValues.ProductNum;
                const Index = this.props.dependentValues.customer_id;
                that.removeCustomer(Index);
              }}
            >X
            </Button>
          </span>
        );
      },
    });

    const columns = [
      {
        name: <Translate value="del" />,
        width: 50,
        formatter: delFormatter,
        getRowMetaData: row => row,
      },
      {
        key: 'customer_name',
        name: <Translate value="customer_name" />,
        width: 200,
        resizable: false,
        sortable: true,
        filterable: true,
      },
      {
        key: 'customer_num',
        name: <Translate value="customer_num" />,
        width: 160,
        resizable: true,
        sortable: true,
        filterable: true,
      },
    ];

    const getRows = () => Data.Selectors.getRows(this.state);
    const getSize = () => getRows().length;
    const rowGetter = (rowIdx) => {
      const rows = getRows();
      return rows[rowIdx];
    };
    const handleFilterChange = (filter) => {
      const newFilters = Object.assign({}, this.state.filters);
      if (filter.filterTerm) {
        newFilters[filter.column.key] = filter;
      } else {
        delete newFilters[filter.column.key];
      }
      this.setState({ filters: newFilters });
    };
    const onClearFilters = () => {
      this.setState({ filters: {} });
    };
    const handleGridSort = (sortColumn, sortDirection) => {
      const state = Object.assign({}, this.state, { sortColumn, sortDirection });
      this.setState(state);
    };

    const showInvite = false;
    let inviteDisabled = !this.props.billing;

    if(showInvite && this.props.billing) {
      const {Email, Street, City, Zip, Telephone, State} = this.props.billing;
      inviteDisabled = !(Email && Street && City && Zip && Telephone && State && this.state.businessType && this.props.Name && this.props.ContactName && this.props.currentCustomerDetail && this.props.currentCustomerDetail.Customer_id);
    }

    const handleInvite = () => {
      const callBack = () => {
        alert('Invitation sent successfully')
      }
      const {Email, Street, City, Zip, Telephone, State} = this.props.billing;
      const data = {
        company_id: this.props.Company_id,
        customer_id:this.props.currentCustomerDetail.Customer_id,
        name: this.props.Name,
        contact: this.props.ContactName,
        email: Email,
        phone: Telephone,
        businessType: this.state.businessType,
        street: Street,
        state: State,
        city: City,
        zip: Zip,
      }
      this.props.fetchInviteCustomer(data, callBack)
    }

    if (this.props.detailIsLoading && !this.props.detailError) {
      return (
        <ContentWrapper><br />...<Translate value="reading_data" /></ContentWrapper>
      );
    } else if (this.props.detailError) {
      return (
        <ContentWrapper>
          <div className="alert alert-danger">{JSON.stringify(this.props.error)}</div>
        </ContentWrapper>
      );
    }

    const {
      currentCustomer
    } = this.props;
    const token = localStorage.getItem('token');

    const memberCardURL = `${ROOT_URL}v1/customer/print_member/${currentCustomer && currentCustomer.Customer_id}?Bearer=${token}`;

    return (
      //---------------
      // Begin HTML
      //---------------
      <ContentWrapper>
        <form method="get" action="#" onSubmit={handleSubmit(this.handleFormSubmit.bind(this))}>
          {/* Nav Trail */}
          {this.breadcrumb()}
          {/* Breadcrumb Buttons */}
          <ButtonToolbar>
            {
              isFJ &&
              <Button
                bsStyle="success"
                type="button"
                onClick={() => this.openAgentModal()}
                disabled={this.context.router.routes[1].path === 'customers/new'}
              >
                <em className="fa fa-pencil" /><Translate value="agents" />
              </Button>
            }
            {
              (isWIZ || isMAG || isLE) &&
              <Button
                bsStyle="success"
                type="button"
                onClick={() => this.openPTModal()}
                disabled={this.context.router.routes[1].path === 'customers/new'}
              >
                <em className="fa fa-pencil" /><Translate value="price_table" />
              </Button>
            }
            {
              showInvite && <Button
              bsStyle="success"
              type="button"
              onClick={(e)=>{
                e.stopPropagation();
                handleInvite();
              }}
              disabled={inviteDisabled}
            >
              <Translate value="invite" />
            </Button>
            }
            <Button
              bsStyle="success"
              type="button"
              onClick={handleSubmit(this.handleFormSubmit.bind(this))}
              disabled={submitting || isEditing || isCreating || vakSave}
            >
              <em className="fa fa-save" /><Translate value="save" />
            </Button>
            <Button
              bsStyle="danger"
              type="reset"
              href="/customers"
            >
              <em className="fa fa-close" /><Translate value="cancel" />
            </Button>
          </ButtonToolbar> {/* End Breadcrumb Buttons */}
          <Grid id="customer-form">
            {/* Row Wrapper */}
            <Row>
              {/* Customer Details */}
              <Col sm={8}>
                <Panel id="customer-details" style={{height: isSV ? "620" : "520px"}} header={customerDetails}>
                  {/* <h3><Translate value="general_information" /></h3> */}
                  <Row>
                    <Col sm={8}>
                      <div className="form-group">
                        <label><Translate value={isVAK ? "company_name" : "name"} /><span className="asteriksReq">*</span></label>
                        <Field name="Name" component={InputField} />
                      </div>
                      {isVAK &&
                      <div className="form-group">
                      <label><Translate value="contact_name" /></label>
                      <Field name="ContactName" component={InputField} />
                    </div>
                      }
                      <div className="form-group description-business-type-form-group">
                        <div className="description-input-field">
                          <label htmlFor="description"><Translate value={isGGI ? "chinese_name" : "description"} /></label>
                          <Field name="Description" component={InputField} className="inputFieldStyle" />
                        </div>
                        <div className="business-type-form-group">
                          <label htmlFor="business-type"><Translate value="business_type" /></label>
                          <GenericSelection
                            options={businessTypeOptions}
                            value={this.state.businessType}
                            setSelected={(option) => {
                              const route = this.props.route;
                              if (isGGI && route.path === 'customers/new') {
                                const success = (field, value) => {
                                  this.props.setDefaultOfForm(field, value, 'customerForm');
                                }
                                this.props.generateCustomerNoWithBusinessType({
                                  businesstype: option.value,
                                  businesstype_shorename: option.num
                                }, (value) => success('CustomerNum', value));
                                this.props.generateRefNoWithBusinessType({
                                  businesstype: option.value,
                                  businesstype_shorename: option.abbr
                                }, (value) => success('RefNum', value));
                                this.setState({ businessType: option.value });
                              } else {
                                this.setState({ businessType: option.value });
                              }
                            }}
                          />
                        </div>
                        {isCalco &&
                          <div className="business-type-form-group">
                            <label htmlFor="business-type"><Translate value="payment_method" /></label>
                            <GenericSelection
                              options={paymentMethodOptions}
                              value={this.state.IsStripe}
                              setSelected={(e) => { this.setState({ IsStripe: e.value }); }}
                            />
                          </div>
                        }
                      </div>
                    </Col>
                    <Col sm={4}>
                      {/* <h3><Translate value="payment_information" /></h3> */}
                      <div className="form-group">
                        <label><Translate value="payment_term" />
                          {
                            !isEKC && !isLMH && !isBRO && !isSDR && !isCRW && !isESC && !isSC &&
                            <span className="asteriksReq">*</span>
                          }
                        </label>
                        {this.renderPaymentTerms()}
                      </div>
                      <Row>
                        <Col sm={6}>
                          <div className="form-group">
                            <label><Translate value="credit_limit" /></label>
                            <Field name="CreditLimit" component={renderAfterAddonField} standalone type="text" standalone addonAfter=".00" />
                          </div>
                        </Col>
                        <Col sm={6}>
                          <div className="credit-type-form-group">
                            <label htmlFor="credit-type"><Translate value="credit_status" /></label>
                            <GenericSelection
                              options={creditOptions}
                              value={this.state.creditStatus}
                              setSelected={(e) => { this.setState({ creditStatus: e.value }); }}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col sm={7}>
                      <Row>
                        <Col sm={isESC ? 4 : 3}>
                          <div className="form-group">
                            <label><Translate value="cust_no" />{!isVAK && <span className="asteriksReq">*</span>}</label>
                            <Field name="CustomerNum" component={InputField} disabled={this.isCustomerNumDisabled() || isVAK}/>
                          </div>
                        </Col>
                        {
                          !isESC &&
                          <Col sm={3}>
                            <div className="form-group">
                              <label><Translate value={isOLG ? "item_no" : "ref_num"} />
                            { (!isEKC && !isLMH && !isBRO && !isSDR && !isCRW && !isSV && !isSC) &&
                                  <span className="asteriksReq">*</span>
                                }
                              </label>
                              <Field name="RefNum" component={InputField} />
                            </div>
                          </Col>
                        }
                        {isSV ?
                          <Col sm={3} className="no-padding">
                            <div className="form-group">
                              <label><Translate value="discount" /></label>
                              <Field name="Discount" component={InputField} />
                            </div>
                          </Col>
                          :
                          <Col sm={6} className="no-padding">
                            <Field name="PriceLevel" component={PriceLevel} isRequired={!isESC} />
                          </Col>
                        }
                      </Row>
                      <Row>
                        {
                          !isGGI && (<Col sm={4}>
                            <div className="form-group">
                              <label><Translate value="ein" /></label>
                              <Field name="EIN" component={InputField} />
                            </div>
                          </Col>
                          )
                        }
                        {
                          !isGGI && !isESC && !isBRO && (<Col sm={4}>
                            <div className="form-group">
                              <label><Translate value={isVAK ? "license_number" : "driver_license"} /></label>
                              <Field name="DLN" component={InputField} />
                            </div>
                          </Col>
                          )
                        }
                         {
                          isBRO && (<Col sm={4}>
                            <div className="form-group">
                              <label><Translate value="certification_type" /></label>
                              <Field name="CertificationType" component={InputField} />
                            </div>
                          </Col>
                          )
                        }
                        {
                          isESC && (<Col sm={4}>
                            <div className="form-group">
                              <label><Translate value="Phone_number" /></label>
                              <Field name="Billing.Telephone" component={InputField} />
                            </div>
                          </Col>)
                        }
                        <Col sm={3}>
                          <div className="form-group">
                            <label><Translate value="reseller" /></label>
                            <Field name="Reseller" component={InputField} />
                          </div>
                        </Col>
                        {
                          isOLG && (<Col sm={4}>
                            <div className="form-group">
                              <label><Translate value="business_phone" /></label>
                              <Field name="Business_Phone" component={InputField} />
                            </div>
                          </Col>)
                        }
                        {
                          isGGI && (<Col sm={3}>
                            <div className="form-group">
                              <label><Translate value="customer_id" /></label>
                              <Field name="Old_Customer_id" component={InputField} />
                            </div>
                          </Col>)
                        }
                        {
                          isGGI && (<Col sm={3}>
                            <div className="form-group">
                              <label><Translate value="supervisor" /></label>
                              <Field name="Supervisor_id" component={Selection} options={this.getUsers()} />
                            </div>
                          </Col>)
                        }
                        {
                          isGGI && (<Col sm={3}>
                            <div className="form-group">
                              <label><Translate value="customer_service" /></label>
                              <Field name="Customer_Service_id" component={Selection} options={this.getUsers()} />
                            </div>
                          </Col>)
                        }
                        {
                          (isLAP || isAPD) && (<Col sm={3}>
                            <div className="form-group">
                              <label><Translate value="route_id" /></label>
                              <Field name="Route_id" component={InputField} />
                            </div>
                          </Col>)
                        }
                      </Row>
                      {isVAK && <Row>
                        <Col sm={4}>
                            <div className="form-group">
                              <Button
                                bsStyle="primary"
                                type="button"
                                onClick={()=>{
                                  this.setState({
                                    isCompaniesCheckedVisible: true,
                                  })
                                }}
                                disabled={!(this.props.currentCustomer && this.props.currentCustomer.Customer_id)}
                              >
                                <Translate value="duplicate_customer" />
                              </Button>
                            </div>
                          </Col>
                        </Row>}
                      {(isLMH || isBRO || isSDR || isCRW || isSC) &&
                        <Row>
                          <Col sm={4}>
                          <div className="form-group">
                          <label><Translate value="rating" /></label>
                          <Field name="rating" matchPos="any" component={Selection} options={ratingOptions} />
                            {/* <GenericSelection
                              options={ratingOptions}
                              value={this.state.rating}
                              setSelected={(e) => { this.setState({ rating: e.value }); }}
                            /> */}
                          </div>
                          </Col>
                          {
                          isBRO && (<Col sm={4}>
                            <div className="form-group">
                              <label><Translate value={isVAK ? "license_number" : "driver_license"} /></label>
                              <Field name="DLN" component={InputField} />
                            </div>
                          </Col>
                          )
                        }
                        </Row>
                      }
                      {
                        (isLAP || isAPD) &&
                         <Row>
                         <Col sm={6}>
                             <div className="form-group">
                               <label>Grace Period</label>
                               <Field name="GracePeriod" component={InputField} />
                             </div>
                           </Col>
                           </Row>
                      }
                      {isDAICHEONG &&
                        <Row>
                        <Col sm={6}>
                            <div className="form-group">
                              <label>Overdue Grace Period (Days)</label>
                              <Field name="OverdueTime" component={InputField} />
                            </div>
                          </Col>

                          <Col sm={6}>
                            <div className="form-group">
                              <label>Overdue Amount ($)</label>
                              <Field name="OverdueAmount" component={InputField} />
                            </div>
                          </Col>
                      </Row>
                      }
                       {/* {isGGI &&
                        <Row>
                          <Col sm={6}>
                            <div className="form-group">
                              <label>Overdue Grace Amount ($)</label>
                              <Field name="OverdueAmount" component={InputField} />
                            </div>
                          </Col>
                      </Row>
                      } */}
                      <Row>
                        {isLE &&
                          <div className="credit-type-form-group">
                            <label htmlFor="credit-type"><Translate value="order_type" /><span className="asteriksReq">*</span></label>
                            <GenericSelection
                              options={orderTypeOptions}
                              value={this.state.orderType}
                              setSelected={(e) => {this.setState({ orderType: e.value }); }}
                            />
                          </div>
                        }
                      </Row>
                      {
                        (isCT || isARC) &&
                        <Row>
                          <Col sm={4}>
                            <div className="form-group">
                              <label><Translate value="member_card" /></label>
                              <Field name="MemberCard" component={InputField} disabled />
                            </div>
                          </Col>
                          <Col sm={4}>
                            <div className="form-group">
                              <label><Translate value="member_card_download" /></label>
                              <Button
                                bsStyle="success"
                                type="button"
                                href={memberCardURL}
                              // disabled={!this.state.selectedRows || this.state.selectedRows.length !== 1}
                              >
                                <em className="fa fa-download" /><Translate value="member_card" />
                              </Button>
                            </div>
                          </Col>
                          <Col sm={4}>
                            <div className="form-group">
                              <label><Translate value="giftcard_balance" /></label>
                              <Field name="giftcard_balance" component={InputField} disabled />
                            </div>
                          </Col>
                        </Row>
                      }
                      {
                        isESC &&
                        <Row>
                          <Col sm={11}>
                            <div className="form-group">
                              <label><Translate value="email" /></label>
                              <Field
                                name="Billing.Email"
                                component="Textarea"
                                className="form-control resize-vertical"
                                style={{ minHeight: '40px' }}
                                resize="vertical"
                              />
                            </div>
                          </Col>
                        </Row>
                      }
                    </Col>
                    <Col sm={3}>
                      {!isGGI && <Field name="IsWholesale" component={renderRadios} />}
                      {!(isEKC || isHMM || isLMH || isBRO || isSDR || isCRW) &&
                        <Row className="form-horizontal">
                          <div className="form-group">
                            <label className="col-sm-6"><Translate value="resale_no" /></label>
                            <div className="col-sm-6">
                              <Field name="Wholesale_ResaleNo" component={InputField} />
                            </div>
                          </div>
                        </Row>
                      }
                      {
                        isCO && <Row className="form-horizontal">
                          <div className="form-group">
                            <label className="col-sm-6"><Translate value="customer_discount" /></label>
                            <div className="col-sm-6">
                              <Field name="DiscountPercentage" component={InputField} />
                            </div>
                          </div>
                        </Row>
                      }
                      {!(isGGI || isOLG) && <Field name="IsShowPrice" component={renderRadios} />}
                      <Field name="IsActive" component={renderRadios} paymentTerm_id={this.props.paymentTerm_id} setDefaultOfForm={this.props.setDefaultOfForm} />
                      <Field name="IsInternal" component={renderRadios} paymentTerm_id={this.props.paymentTerm_id} setDefaultOfForm={this.props.setDefaultOfForm} />
                      {this.renderHasCRV()}
                      {this.renderSharedCompany()}
                      {this.renderEmailInvoice()}
                    </Col>
                    {
                      isGGI &&
                      <Col sm={6}>
                        <div className="form-group">
                          <label><Translate value="bad_credit_reason" /></label>
                          <Field name="bad_credit_reason" maxLength={150} component={InputField} />
                        </div>
                      </Col>
                    }
                    {
                      !(isGGI || isEKC || isLMH || isBRO || isSDR || isCRW) &&
                      <Col sm={6}>
                        <div className="form-group">
                          <label><Translate value={isSV ? "customer_permanent_note" : "notation"} /></label>
                          <Field name="Notation" maxLength={150} component={InputField} />
                        </div>
                      </Col>
                    }

                    {/* {
                    isSV &&
                      <Col sm={6}>
                        <div className="form-group">
                          <label><Translate value="note" /></label>
                          <Field name="Note" maxLength={150} component={InputField} />
                        </div>
                      </Col>
                  } */}
                    {
                      !isSV &&
                      <Col sm={6}>
                        <div className="form-group">
                          <label><Translate value="default_sales" /></label>
                          {this.renderDefaultSales()}
                        </div>
                      </Col>
                    }
                    {(isEKC || isLMH || isBRO || isSDR || isCRW) &&
                      <Col sm={6}>
                        <div className="form-group">
                          <label><Translate value="create_datetime" /></label>
                          <Field name="CreateDate" component={DatePicker} />
                          {/*  selected={this.state.prevOrderDate}  */}
                        </div>
                      </Col>
                    }
                  </Row>
                  {isSV &&
                    <Row>
                      <Col sm={6}>
                        <div className="form-group">
                          <label>Teapplix Collect Shipping Profile ID</label>
                          <Field name="TeapplixCollectShippingProfile" maxLength={150} component={InputField} />
                        </div>
                      </Col>
                      <Col sm={6}>
                        <div className="form-group">
                          <label>Teapplix 3rd Party Shipping Profile ID</label>
                          <Field name="Teapplix3rdPartyShippingProfile" maxLength={150} component={InputField} />
                        </div>
                      </Col>
                    </Row>
                  }

                  {
                    isSV &&
                    <Row>
                      <Col sm={6}>
                        <div className="form-group">
                          <label><Translate value="default_sales_#1" /></label>
                          {this.renderDefaultSales()}
                        </div>
                      </Col>
                      <Col sm={6}>
                        <div className="form-group">
                          <label><Translate value="default_commission_#1" /></label>
                          <Field name="Commission" maxLength={150} component={InputField} disabled />
                        </div>
                      </Col>
                    </Row>
                  }
                  {
                    isSV &&
                    <Row>
                      <Col sm={6}>
                        <div className="form-group">
                          <label><Translate value="default_sales_#2" /></label>
                          {this.renderDefaultSales2()}
                        </div>
                      </Col>
                      <Col sm={6}>
                        <div className="form-group">
                          <label><Translate value="default_commission_#2" /></label>
                        <Field name="Commission2" maxLength={150} component={InputField} disabled />
                        </div>
                      </Col>
                    </Row>
                  }
                  <Row>
                    {/* { */}
                    {/*   !(isSV || isEKC || isLMH) && */}
                    {/*   <Col sm={6}> */}
                    {/*     <div className="form-group"> */}
                    {/*       <label><Translate value="notation" /></label> */}
                    {/*       <Field name="Notation" maxLength={150} component={InputField} /> */}
                    {/*     </div> */}
                    {/*   </Col> */}
                    {/* } */}
                    {
                      isSV &&
                      <Col sm={6}>
                        <div className="form-group">
                          <label><Translate value="start_date" /></label>
                          <Field name="StartDate" component={DatePicker} />
                        </div>
                      </Col>
                    }
                    {(!isEKC && !isLMH && !isBRO && !isSDR && !isCRW) &&
                      <Col sm={6}>
                        <div className="form-group">
                          <label><Translate value="create_datetime" /></label>
                          <Field name="CreateDate" component={DatePicker} />
                          {/*  selected={this.state.prevOrderDate}  */}
                        </div>
                      </Col>
                    }
                    {
                      isGFD &&
                      <Col sm={6}>
                        <div className="form-group">
                          <label><Translate value="assoc_company" /></label>
                          {this.renderCompany()}
                        </div>
                      </Col>
                    }
                    {this.renderLastOrderDate()}
                  </Row>
                  {
                    (isEKC || isLMH || isBRO || isSDR || isCRW) &&
                    <Row>
                      <Col sm={6}>
                        <div className="form-group">
                          <label><Translate value="notation" /></label>
                          <Field
                            name="Notation"
                            component="Textarea"
                            className="form-control resize-vertical"
                            style={{ minHeight: '80px' }}
                            resize="vertical"
                          />
                          {/* <Field name="Notation" maxLength={150} component={InputField} /> */}
                        </div>
                      </Col>
                    </Row>
                  }
                </Panel>
              </Col>
              {/* End Customer Details */}
              {/* Emails */}
              <Col sm={4}>
                <Panel id="e-mails" header={emails}>
                  <Row>
                    <FieldArray name="email" component={renderEmails} already={this.state.is_already_binding}/>
                  </Row>
                </Panel>
              </Col>
              {/* End Emails */}
            </Row>
            <Row>
              {/* Billing Details */}
              <Col sm={4}>
                <Panel id="billing-details" style={{height: isSV ? "580px" : '490px'}} header={billingDetails}>
                  {/* <h3><Translate value="billing_address" /></h3> */}
                  {
                    isSV &&
                    <Row className="form-horizontal">
                      <div className="form-group">
                        <label className="col-sm-2"><Translate value="title" /></label>
                        <div className="col-sm-10">
                          <Field name="Billing.Title" component={InputField} />
                        </div>
                      </div>
                    </Row>
                  }
                  {
                    !isSV &&
                    <Row className="form-horizontal">
                      <div className="form-group">
                        <label className="col-sm-2">
                          <Translate value="name" />
                          {isESC && <span className="asteriksReq">*</span>}
                        </label>
                        <div className="col-sm-10">
                          <Field name="Billing.AddressName" component={InputField} />
                        </div>
                      </div>
                    </Row>
                  }
                  {
                    isSV &&
                    <Row className="form-horizontal">
                      <div className="form-group">
                        <label className="col-sm-2"><Translate value="name" /></label>
                        <div className="col-sm-7">
                          <Field name="Billing.AddressName" component={InputField} />
                        </div>
                        <div className='col-sm-3'>
                          <Button
                            bsStyle="default"
                            className="auto-fill"
                            type="button"
                            onClick={this.copyToBilling.bind(this)}
                          >
                            <em className="fa fa-edit" /><Translate value="fill" />
                          </Button>
                        </div>
                      </div>
                    </Row>
                  }
                  <Row>
                    <Col sm={12}>
                      <div className="form-group">
                        <label>
                          <Translate value="street" />
                          {!isESC && <span className="asteriksReq">*</span>}
                        </label>
                        <Field name="Billing.Street" component={InputField} />
                      </div>
                    </Col>
                  </Row>
                  {
                    isSV &&
                    <Row className="form-horizontal">
                      <div className="form-group">
                        <label className="col-sm-2"><Translate value="name_2" /></label>
                        <div className="col-sm-10">
                          <Field name="Billing.AddressName1" component={InputField} />
                        </div>
                      </div>
                    </Row>
                  }
                  {isSV &&
                    <Row>
                      <Col sm={12}>
                        <div className="form-group">
                          <label><Translate value="street_2" /><span className="asteriksReq">*</span></label>
                          <Field name="Billing.Street1" component={InputField} />
                        </div>
                      </Col>
                    </Row>
                  }
                  <Row>
                    <Col sm={6}>
                      <div className="form-group">
                        <label>
                          <Translate value="city" />
                          {!isESC && <span className="asteriksReq">*</span>}
                        </label>
                        <Field name="Billing.City" component={InputField} />
                      </div>
                    </Col>
                    <Col sm={3}>
                      <div className="form-group">
                        <label>
                          <Translate value="state" />
                          {!isESC && <span className="asteriksReq">*</span>}
                        </label>
                        <Field name="Billing.State" component={InputField} />
                      </div>
                    </Col>
                    <Col sm={3}>
                      <div className="form-group">
                        <label>
                          <Translate value="zip" />
                          {!isESC && <span className="asteriksReq">*</span>}
                        </label>
                        <Field name="Billing.Zip" component={InputField} />
                      </div>
                    </Col>
                  </Row>
                  {
                    isSV &&
                    <Row>
                      <Col sm={6}>
                        <div className="form-group">
                          <label><Translate value="country" /><span className="asteriksReq">*</span></label>
                          <Field name="Billing.Country" component={InputField} />
                        </div>
                      </Col>
                    </Row>
                  }
                  {
                    isVAK && (this.props.selectedCompany || {value: ''}).value == 6 &&
                    <Row>
                      <Col sm={6}>
                        <div className="form-group">
                          <label><Translate value="country" /></label>
                          <Field name="Billing.Country"
                          matchPos="any"
                          component={SelectionWithProps}
                          options={countriesOptions} />
                        </div>
                      </Col>
                    </Row>
                  }

                  {/* <h3><Translate value="billing_contact" /></h3> */}
                  <Row>
                    <Col sm={(isTQ || isMultiWH) ? 6 : 4}>
                      <div className="form-group">
                        <label><Translate value={isDAICHEONG ? "ap_name" : "first_name"} /></label>
                        <Field name="Billing.FirstName" component={InputField} />
                      </div>
                    </Col>
                    <Col sm={(isTQ || isMultiWH) ? 6 : 4}>
                      <div className="form-group">
                        <label><Translate value={isDAICHEONG ? "buyer_name" : "last_name"} /></label>
                        <Field name="Billing.LastName" component={InputField} />
                      </div>
                    </Col>
                    {
                      !(isTQ || isMultiWH) &&
                      <Col sm={4}>
                        <div className="form-group">
                          <label><Translate value="email" /></label>
                          <Field name="Billing.Email" component={InputField} maxLength={200} />
                        </div>
                      </Col>
                    }
                  </Row>
                  <Row>
                    <Col sm={4}>
                      <div className="form-group">
                        <label>
                          <Translate value={isDAICHEONG ? "ap_phone" : "tel"} />
                          {!isESC && <span className="asteriksReq">*</span>}
                        </label>
                        <Field name="Billing.Telephone" component={InputField} />
                      </div>
                    </Col>
                    <Col sm={4}>
                      <div className="form-group">
                        <label><Translate value={isDAICHEONG ? "buyer_phone" : "cell_phone"} /></label>
                        <Field name="Billing.Cellphone" component={InputField} />
                      </div>
                    </Col>
                    <Col sm={4}>
                      <div className="form-group">
                        <label><Translate value="fax" /></label>
                        <Field name="Billing.Fax" component={InputField} />
                      </div>
                    </Col>
                  </Row>
                  {
                    (isTQ || isMultiWH) &&
                    <Row>
                      <Col sm={12}>
                        <div className="form-group">
                          <label><Translate value="email" /></label>
                          <span className="asteriksReq"><Translate value="press_enter_for_emails" /></span>
                          <Field
                            name="Billing.Email"
                            component="Textarea"
                            className="form-control resize-vertical"
                            style={{ minHeight: '40px' }}
                            resize="vertical"
                          />
                        </div>
                      </Col>
                    </Row>
                  }
                   {isVAK &&
                  <Row>
                  <Col sm={12}>
                    <div className="form-group">
                      <label>
                        <Translate value="website" />
                      </label>
                      <Field name="Billing.website" component={InputField} />
                    </div>
                  </Col>
                </Row>
                  }
                </Panel>
              </Col>
              {/* End Billing Details */}
              {/* Mailing Details */}
              <Col sm={4}>
                {this.renderMailingDetails()}
                {this.renderMailingDetailsGGI()}
              </Col>
              {/* End Mailing Details */}
              {/* Shipping Details */}
              <Col sm={4}>
                <Panel id="shipping-details" style={{height: isSV ? '580px' : '550px'}} header={shippingDetails}>
                  <h3><Translate value="shipping_address" /></h3>
                  <FieldArray
                    name="Shipping"
                    component={renderShipping}
                    billing={this.props.billing}
                    selectedCompany={this.props.selectedCompany}
                    shipping={this.props.shipping} // {this.props.billingAddress}
                    changeFieldArrayOfForm={this.props.changeFieldArrayOfForm}
                  />
                </Panel>
              </Col>
              {/* End Shipping Details */}
            </Row>
            {/* End Row Wrapper */}
            <Row>
              <Col sm={8}>
                {this.renderAttach()}
              </Col>
            </Row>
            {this.props.isCreating || this.props.isEditing && <Spinner />}
            {/* this.props.createError && <div className="alert alert-danger marginTopStyle">{JSON.stringify(this.props.createError)}</div> */}
            {/* this.props.editError && <div className="alert alert-danger marginTopStyle">{JSON.stringify(this.props.editError)}</div> */}
          </Grid>
          <SkyLightStateless dialogStyles={createDialogStyle} isVisible={this.state.confirmOpen} onCloseClicked={() => { this.closeConfirm() }} title={confirmAction}>
            <ConfirmActionModal case={this.state.case} closeC={this.closeConfirm} />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStyle2} isVisible={this.state.agentModalOpen} onCloseClicked={() => { this.closeAgentModal() }} title={agentAction}>
            <AgentChangeModal
              fjCustomerId={this.state.fjCustomerId}
              fetchFJAgents={this.props.fetchFJAgents}
              updateFJAgents={this.props.updateFJAgents}
              deleteFJAgents={this.props.deleteFJAgents}
              closeAgentModal={this.closeAgentModal}
            // salesOrderId={singleSalesOrderId}
            // fetchShippingWeightTracking={this.props.fetchShippingWeightTracking}
            // finalShippingWeight={this.state.finalShippingWeight}
            // onSave={this.onChangeWeightSubmit}
            // onSavePrint={this.onChangeWeightSubmitPrint}
            // onChange={this.onShippingWeightChange}
            />
          </SkyLightStateless>
          <SkyLightStateless dialogStyles={createDialogStylePT} isVisible={this.state.ptModalOpen} onCloseClicked={() => { this.closePTModal() }} title={priceTable}>
            <PriceTableModal
              fjCustomerId={this.state.fjCustomerId}
              fetchPT={this.props.fetchPT}
              updatePT={this.props.updatePT}
              // deleteFJAgents = {this.props.deleteFJAgents}
              closePTModal={this.closePTModal}
            />
          </SkyLightStateless>
          <SkyLightStateless
          dialogStyles={createDialogStyleDup}
          isVisible={this.state.isCompaniesCheckedVisible}
          onCloseClicked={() => { this.closeCompanies() }}
          title={(<Translate value="duplicate_customer" />)}>
            <DuplicateToCompanyModal
            customerId={this.props.currentCustomer ? this.props.currentCustomer.Customer_id : null}
            companies={this.state.companies}
            onClose={this.closeCompanies}
            />
          </SkyLightStateless>
        </form>
      </ContentWrapper>
      //---------------
      // End HTML
      //---------------
    );
  }
}

export default withRouter(CustomerForm);



// WEBPACK FOOTER //
// ./master/jsx/components/Customers/customerForm.jsx